import { Component, OnInit } from '@angular/core';
import { WinService } from 'src/app/services/win.service';
import { CmsService } from 'src/app/services/api/cms.service';
import { OwlOptions } from "ngx-owl-carousel-o";
import { LangService } from 'src/app/services/lang/lang.service';

@Component({
  selector: 'app-customer-block',
  templateUrl: './customer-block.component.html',
  styleUrls: ['./customer-block.component.scss']
})
export class CustomerBlockComponent implements OnInit {

  baseUrl: any = "";

  customOptions: OwlOptions = {
    loop: true,
    nav: false,
    dots: false,
    navSpeed: 1000,
    items: 1,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    margin: 15,
    responsive: {
      0: { items: 2 },
      400: { items: 3 },
      740: { items: 4 },
      940: { items: 5 },
    },
  };

  customers: any = null;

  constructor(
    public winService: WinService,
    public cms: CmsService,
    public lang: LangService
  ) {
    ;
    this.baseUrl = this.cms.getUrl('');
  }

  ngOnInit(): void {
    this.cms.getBlock(54, false, true).then(res => {
      this.customers = res['content'];
    });
  }

}
